<template>
  <!-- 黑色导航-----isMaster ? 'force-black' : '' -->
  <header :class="['header', enableFloating ? 'float-mode transparent-mode' : '', showNoticeBar ? 'has-notice' : '',  siteConfigColor == 'black' ? 'force-black' : '']">
    <div class="header-wrapper">
      <!-- 公告 -->
      <div :class="['notice flex-hc',fixed?'fixed':'']"  v-show="showNoticeBar">
        <template v-if="notice && notice.status == 1">
          <p v-if="notice.pc_url">
            <span class="gg_text">{{notice.title }}</span>
            <a v-if="notice.pc_url" class="gg_link" :href="notice.pc_url" target="_blank">{{notice.title_online}}</a>
          </p>
          <!-- <p v-else>
            <span class="gg_text">{{ notice.title }}</span>
          </p> -->
          <i class="iconfont icon-close" @click="hideNoticeBar">&#xe615;</i>
        </template>
      </div>
      <!-- 工具栏 -->
      <div class="toolbar show-for-md hide">
        <div class="layout">
          <div class="ms-row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <ul class="no-bullet toolbar-items">
                <li class="toolbar-item">
                  <router-link class="toolbar-item-link" to="/groupe">公司</router-link>
                </li>
                <li class="toolbar-item">
                  <router-link class="toolbar-item-link" to="/fondation">慈善</router-link>
                </li>
                <li class="toolbar-item">
                  <a class="toolbar-item-link" href="/expertise">我们的专长</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="text-align: right;">
              <!-- <ul class="no-bullet toolbar-items">
                <li class="toolbar-item">
                  <a class="toolbar-item-link" href="/">Service clients</a>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 主体 -->
      <div :class="['x-wrapper']">
        <!-- 导航栏 -->
        <div class="navbar">
          <div :class="['navbar-wrapper', showNoticeBar ? 'has-notice' : '']">
            <div class="layout">
              <div class="ms-row">
                <div class="col-xs-12">
                  <div class="header__logo">
                    <template v-if="!isMaster">
                      <router-link to="/hair-rituel">
                        <span class="l-header__logo-wrapper">
                          <span class="show-for-md">
                            <img
                              src="@/assets/imgs/logos/hair_rituel-logo_black-bigger.svg"
                              class="svg-inline logo-bigger-black svg-inline--default"
                              alt="Sisley Paris"
                            />
                          </span>
                          <span class="hide-for-md">
                            <img
                              src="@/assets/imgs/logos/hair_rituel-logo_black.svg"
                              class="svg-inline logo-small-black svg-inline--default"
                              alt="Sisley Paris"
                            />
                          </span>
                        </span>
                        <span class="l-header__logo-wrapper l-header__logo--white">
                          <span class="show-for-md">
                            <img
                              src="@/assets/imgs/logos/hair_rituel-logo_white-bigger.svg"
                              class="svg-inline logo-bigger-white svg-inline--transparent"
                              alt="Sisley Paris"
                            />
                          </span>
                          <span class="hide-for-md">
                            <img
                              src="@/assets/imgs/logos/hair_rituel-logo_white.svg"
                              class="svg-inline logo-small-white svg-inline--transparent"
                              alt="Sisley Paris"
                            />
                          </span>
                        </span>
                      </router-link>
                    </template>
                    <template v-else>
                      <router-link to="/">
                        <span class="l-header__logo-wrapper">
                          <span class="show-for-md">
                            <img
                              src="@/assets/imgs/logos/sisley-logo_black-bigger.svg"
                              class="svg-inline logo-bigger-black svg-inline--default"
                              alt="Sisley Paris"
                            />
                          </span>
                          <span class="hide-for-md">
                            <img src="@/assets/imgs/logos/sisley-logo_black.svg" class="svg-inline logo-small-black svg-inline--default" alt="Sisley Paris" />
                          </span>
                        </span>
                        <span class="l-header__logo-wrapper l-header__logo--white">
                          <span class="show-for-md">
                            <img
                              src="@/assets/imgs/logos/sisley-logo_white-bigger.svg"
                              class="svg-inline logo-bigger-white svg-inline--transparent"
                              alt="Sisley Paris"
                            />
                          </span>
                          <span class="hide-for-md">
                            <img
                              src="@/assets/imgs/logos/sisley-logo_white.svg"
                              class="svg-inline logo-small-white svg-inline--transparent"
                              alt="Sisley Paris"
                            />
                          </span>
                        </span>
                      </router-link>
                    </template>
                  </div>
                  <div class="show-for-md">
                    <div class="sisley-club">
                      <router-link class="club-link" to="/member-club">
                        <img src="@/assets/imgs/logos/sisley_club.svg" class="svg-inline my-sisley-club-logo" alt="My Sisley Club" />
                      </router-link>
                      <div class="club-desc">
                        <p class="club-title">My Sisley Club</p>
                      </div>
                    </div>
                  </div>
                  <div class="float-right">
                    <div class="navbar-contact float-left">
                      <button class="navbar-trigger" @click="toContact">
                        <!-- <i class="iconfont svg-inline svg-inline--default">&#xe663;</i>
                        <i class="iconfont svg-inline svg-inline--transparent">&#xe663;</i> -->
                        <svg
                          class="svg-inline svg-inline--default"
                          width="20px"
                          height="20px"
                          viewBox="0 0 20 20"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <g stroke="#000" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g transform="translate(1.000000, 1.000000)">
                              <path
                                d="M10.4725152,16.2778092 L8.15995992,16.2778092 C7.86147175,16.2778092 7.62296453,16.5025173 7.62289919,16.7751099 L7.62289919,17.692394 C7.62295364,17.9650297 7.86146389,18.1897491 8.15995992,18.1897491 L10.4726446,18.1897491 C10.7711315,18.1897491 11.0095711,17.9650364 11.0094726,17.692424 L11.0094726,16.7751159 C11.0094726,16.5025163 10.770988,16.2778092 10.4725152,16.2778092 Z"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M1.5,7 L2.9,7 C2.95522847,7 3,7.04477153 3,7.1 L3,12.9 C3,12.9552285 2.95522847,13 2.9,13 L1.5,13 C0.671572875,13 1.01453063e-16,12.3284271 0,11.5 L0,8.5 C-1.01453063e-16,7.67157288 0.671572875,7 1.5,7 Z"
                              ></path>
                              <path
                                d="M17,7 L18.4,7 C18.4552285,7 18.5,7.04477153 18.5,7.1 L18.5,12.9 C18.5,12.9552285 18.4552285,13 18.4,13 L17,13 C16.1715729,13 15.5,12.3284271 15.5,11.5 L15.5,8.5 C15.5,7.67157288 16.1715729,7 17,7 Z"
                                transform="translate(17.000000, 10.000000) scale(-1, 1) translate(-17.000000, -10.000000) "
                              ></path>
                              <path d="M17.5,7 C17.5,2.582 13.918,0 9.5,0 C5.082,0 1.5,2.582 1.5,7"></path>
                              <path d="M16.5,13 C16.5,15.209139 14.709139,17 12.5,17 L10.5,17 L10.5,17"></path>
                            </g>
                          </g>
                        </svg>
                        <svg
                          class="svg-inline svg-inline--transparent"
                          width="20px"
                          height="20px"
                          viewBox="0 0 20 20"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <g stroke="#FFF" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g transform="translate(1.000000, 1.000000)">
                              <path
                                d="M10.4725152,16.2778092 L8.15995992,16.2778092 C7.86147175,16.2778092 7.62296453,16.5025173 7.62289919,16.7751099 L7.62289919,17.692394 C7.62295364,17.9650297 7.86146389,18.1897491 8.15995992,18.1897491 L10.4726446,18.1897491 C10.7711315,18.1897491 11.0095711,17.9650364 11.0094726,17.692424 L11.0094726,16.7751159 C11.0094726,16.5025163 10.770988,16.2778092 10.4725152,16.2778092 Z"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M1.5,7 L2.9,7 C2.95522847,7 3,7.04477153 3,7.1 L3,12.9 C3,12.9552285 2.95522847,13 2.9,13 L1.5,13 C0.671572875,13 1.01453063e-16,12.3284271 0,11.5 L0,8.5 C-1.01453063e-16,7.67157288 0.671572875,7 1.5,7 Z"
                              ></path>
                              <path
                                d="M17,7 L18.4,7 C18.4552285,7 18.5,7.04477153 18.5,7.1 L18.5,12.9 C18.5,12.9552285 18.4552285,13 18.4,13 L17,13 C16.1715729,13 15.5,12.3284271 15.5,11.5 L15.5,8.5 C15.5,7.67157288 16.1715729,7 17,7 Z"
                                transform="translate(17.000000, 10.000000) scale(-1, 1) translate(-17.000000, -10.000000) "
                              ></path>
                              <path d="M17.5,7 C17.5,2.582 13.918,0 9.5,0 C5.082,0 1.5,2.582 1.5,7"></path>
                              <path d="M16.5,13 C16.5,15.209139 14.709139,17 12.5,17 L10.5,17 L10.5,17"></path>
                            </g>
                          </g>
                        </svg>
                      </button>
                    </div>
                    <div class="navbar-search float-left">
                      <button class="navbar-trigger" @click="showSearchLayer">
                        <svg
                          class="svg-inline svg-inline--default"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="20"
                          viewBox="0 0 18 17"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#000">
                            <path stroke-linecap="square" d="M17 17l-4-4" />
                            <circle cx="7.5" cy="7.5" r="7" />
                          </g>
                        </svg>
                        <svg
                          class="svg-inline svg-inline--transparent"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="20"
                          viewBox="0 0 18 17"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#FFF">
                            <path stroke-linecap="square" d="M17 17l-4-4" />
                            <circle cx="7.5" cy="7.5" r="7" />
                          </g>
                        </svg>
                      </button>
                    </div>
                    <div class="navbar-account float-left">
                      <button class="navbar-trigger" @click="toAccount">
                        <svg
                          class="svg-inline svg-inline--transparent"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="21"
                          viewBox="0 0 18 19"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#FFF" transform="translate(1)">
                            <path d="M16 19c0-4.418-3.582-7-8-7s-8 2.582-8 7" />
                            <circle cx="8" cy="5" r="4.5" />
                          </g>
                        </svg>
                        <svg
                          class="svg-inline svg-inline--default"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="21"
                          viewBox="0 0 18 19"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#000" transform="translate(1)">
                            <path d="M16 19c0-4.418-3.582-7-8-7s-8 2.582-8 7" />
                            <circle cx="8" cy="5" r="4.5" />
                          </g>
                        </svg>
                      </button>
                    </div>
                    <div class="navbar-minicart float-left">
                      <button class="navbar-trigger" @click="toCart">
                        <svg
                          class="svg-inline svg-inline--transparent"
                          aria-hidden="true"
                          version="1.1"
                          width="18"
                          height="26"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 32"
                          xml:space="preserve"
                        >
                          <g fill="none" stroke="#FFF" fill-rule="evenodd">
                            <g id="picto" transform="translate(0.000000, 5.000000)">
                              <g transform="translate(0.000000, 0.333333)">
                                <path
                                  id="Rectangle-2"
                                  d="M1.8,8.5L0.7,24.6c0,0,0,0.1,0,0.1c0,0.8,0.7,1.5,1.5,1.5h19.7c0,0,0.1,0,0.1,0 c0.8-0.1,1.4-0.8,1.4-1.6L22.2,8.5H1.8z"
                                />
                                <path id="Oval-Copy_1_" d="M17.2,11.3l0-5.7l0-0.8c-0.3-2.4-2.3-4.3-4.8-4.3S7.8,2.4,7.5,4.8l0,0.8v5.7" />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <svg
                          class="svg-inline svg-inline--default"
                          aria-hidden="true"
                          version="1.1"
                          width="18"
                          height="26"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 32"
                          xml:space="preserve"
                        >
                          <g fill="none" stroke="#000" fill-rule="evenodd">
                            <g id="picto" transform="translate(0.000000, 5.000000)">
                              <g transform="translate(0.000000, 0.333333)">
                                <path
                                  id="Rectangle-2"
                                  d="M1.8,8.5L0.7,24.6c0,0,0,0.1,0,0.1c0,0.8,0.7,1.5,1.5,1.5h19.7c0,0,0.1,0,0.1,0 c0.8-0.1,1.4-0.8,1.4-1.6L22.2,8.5H1.8z"
                                />
                                <path id="Oval-Copy_1_" d="M17.2,11.3l0-5.7l0-0.8c-0.3-2.4-2.3-4.3-4.8-4.3S7.8,2.4,7.5,4.8l0,0.8v5.7" />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <span class="navbar-minicart-quantity" v-if="cartTotal > 0">{{ cartTotal }}</span>
                      </button>
                    </div>
                    <button class="navbar-toggler hide-for-md float-right" @click="toExpandMenu">
                      <svg
                        class="svg-inline burger__white svg-inline--transparent"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="13"
                        viewBox="0 0 26 13"
                      >
                        <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square">
                          <path d="M1 .5h24M1 6.5h24M1 12.5h18.45" />
                        </g>
                      </svg>
                      <svg
                        class="svg-inline burger svg-inline--default"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="13"
                        viewBox="0 0 26 13"
                      >
                        <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square">
                          <path d="M1 .5h24M1 6.5h24M1 12.5h18.45" />
                        </g>
                      </svg>
                    </button>
					<div class="navbar-minicart float-left" v-if="$route.name=='sustainability'&&false"  >
						<!-- 发送邮件 -->
						<button  @click="toStb('6')" class="navbar-trigger">发送</button>
					</div>
					<div class="navbar-minicart float-left" v-if="$route.name=='sustainability'" >
						<button  @click="toStb('7')" class="navbar-trigger">
							<img style="width: 30px;height: 30px;" src="@/assets/imgs/sustainability/quanpin.png" />
							<!-- <div style="height: 26px;line-height: 26px;">全屏</div> -->
						</button>
					</div>
					<div class="navbar-minicart float-left" v-if="$route.name=='sustainability'" >
						<button @click="toStb('8')" class="navbar-trigger">
							<!-- <img src="" /> -->
							<img style="width: 22px;height: 30px;" src="@/assets/imgs/sustainability/pdf.png" />
						</button>
					</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 菜单栏 -->
        <div class="menubar show-for-md" @mouseenter="onMenuFocus" @mouseleave="onMenuBlur" v-if="navList && navList.length">
          <div :class="['menu-wrapper', showNoticeBar ? 'has-notice' : '',fixed?'fixed':'']">
            <div class="layout layout-static">
              <div class="ms-row">
                <div class="col-md-9">
                  <nav class="menu-container">
                    <ul class="menu-list no-bullet clearfix">
                      <li
                        v-for="(firstMenu, firstIndex) in navList"
                        :key="`firstMenu-${firstIndex}`"
                        class="menu-item"
                        @mouseenter="onMenuItemFocus"
                        @mouseleave="onMenuItemBlur"
                      >
                        <button class="menu-item-link" @click.prevent="triggerHandler($event, firstMenu.action)">{{ firstMenu.text }}</button>
                        <template v-if="(firstMenu.children && firstMenu.children.length) || (firstMenu.banners && firstMenu.banners.children)">
                          <div class="dropdown-container animated delay-250">
                            <div class="layout">
                              <div class="ms-row">
                                <div class="col-xs-12">
                                  <!-- 二级导航 & 三级导航：无数据亦保留用于占位 -->
                                  <ul class="dropdown-menu">
                                    <template v-if="firstMenu.children && firstMenu.children.length">
                                      <li
                                        class="dropdown-item"
                                        v-for="(secondaryMenu, secondaryIndex) in firstMenu.children"
                                        :key="`secondaryMenu-${secondaryIndex}`"
                                      >
                                        <a href="javascript:void(0)" @click.prevent="triggerHandler($event, secondaryMenu.action)">{{ secondaryMenu.text }}</a>
                                        <ul class="dropdown-submenu">
                                          <li class="dropdown-item" v-for="(thirdMenu, thirdIndex) in secondaryMenu.children" :key="`thirdMenu-${thirdIndex}`">
                                            <a
                                              class="nav-link nav-link--third"
                                              href="javascript:void(0)"
                                              @click.prevent="triggerHandler($event, thirdMenu.action)"
                                              >{{ thirdMenu.text }}</a
                                            >
                                          </li>
                                        </ul>
                                      </li>
                                    </template>
                                  </ul>
                                  <template v-if="firstMenu.banners && firstMenu.banners.children">
                                    <div class="dropdown-layer">
                                      <template v-if="firstMenu.banners.type == 1">
                                        <a
                                          class="dropdown-layer-item"
                                          href="javascript:void(0)"
                                          @click.prevent="triggerHandler($event, banner.action)"
                                          v-for="(banner, idx) in firstMenu.banners.children"
                                          :key="`Menu_${firstIndex}-Banner_${idx}`"
                                        >
                                          <div class="dropdown-layer-item-image-wrapper">
                                            <img class="dropdown-layer-item-image" :src="banner.src" :alt="banner.label" />
                                          </div>
                                          <div class="dropdown-layer-item-label">{{ banner.label }}</div>
                                        </a>
                                      </template>
                                      <template v-if="firstMenu.banners.type == 2">
                                        <a
                                          class="dropdown-layer-item"
                                          href="javascript:void(0)"
                                          @click.prevent="triggerHandler($event, banner.action)"
                                          v-for="(banner, idx) in firstMenu.banners.children"
                                          :key="`Menu_${firstIndex}-Banner_${idx}`"
                                        >
                                          <div class="dropdown-layer-item-image-wrapper">
                                            <img class="dropdown-layer-item-image" :src="banner.src" :alt="banner.flag" />
                                          </div>
                                          <div class="dropdown-layer-item-flag" v-if="banner.flag">{{ banner.flag }}</div>
                                          <div class="dropdown-layer-item-desc" v-if="banner.desc">{{ banner.desc }}</div>
                                        </a>
                                      </template>
                                      <template v-if="firstMenu.banners.type == 3">
                                        <div class="ms-row flex-fill">
                                          <div
                                            class="col-md-3 col-xs-12 col-md-r20"
                                            v-for="(banner, idx) in firstMenu.banners.children"
                                            :key="`Menu_${firstIndex}-Banner_${idx}`"
                                          >
                                            <a class="dropdown-layer-item" href="javascript:void(0)" @click.prevent="triggerHandler($event, banner.action)">
                                              <div class="dropdown-layer-item-image-wrapper">
                                                <img
                                                  class="dropdown-layer-item-image"
                                                  :src="banner.src"
                                                  :srcset="`${banner.srcset || banner.src} 2x`"
                                                  :alt="banner.subtitle"
                                                />
                                              </div>
                                              <div class="dropdown-layer-item-subtitle heading-h4">{{ banner.subtitle }}</div>
                                              <div class="dropdown-layer-item-desc">{{ banner.desc }}</div>
                                            </a>
                                          </div>
                                        </div>
                                      </template>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </li>
					  <template>
						 <!-- <li  v-if="$route.name!='sustainability'"  class="menu-item">
							  <button  @click="$router.push('/sustainabilityView')" class="menu-item-link">{{'品牌故事'}}</button>
						  </li> -->
						   <template v-if="$route.name=='sustainability'" >
							   <li  class="menu-item"><button @click="toStb('1')" class="menu-item-link">home</button> </li>
							   <li  class="menu-item"><button @click="toStb('2')" class="menu-item-link">介绍</button> </li>
							   <li  class="menu-item"><button @click="toStb('3')" class="menu-item-link">减少</button> </li>
							   <li  class="menu-item"><button @click="toStb('4')" class="menu-item-link">创新</button> </li>
							   <li  class="menu-item"><button @click="toStb('5')" class="menu-item-link">保护</button> </li>
						   </template>
					  </template>
					  <!-- <template>
							<li  class="menu-item"><button class="menu-item-link">sustainability</button> </li>
					  </template> -->
                    </ul>
                  </nav>
                </div>
                <div class="col-md-3">
                  <template v-if="isMaster">
                    <router-link to="/hair-rituel" class="menu-logo--large float-right">
                      <img src="@/assets/imgs/logos/hair_rituel-logo_black.svg" class="svg-inline logo-small svg-inline--default" alt="Hair Rituel" />
                      <img
                        src="@/assets/imgs/logos/hair_rituel-logo_white.svg"
                        class="svg-inline logo-small__white svg-inline--transparent"
                        alt="Hair Rituel"
                      />
                    </router-link>
                  </template>
                  <template v-else>
                    <router-link to="/" class="menu-logo--large float-right">
                      <img src="@/assets/imgs/logos/sisley-logo_black.svg" class="svg-inline logo-small svg-inline--default" alt="Sisley Paris" />
                      <img src="@/assets/imgs/logos/sisley-logo_white.svg" class="inline-svg logo-small__white svg-inline--transparent" alt="Sisley Paris" />
                    </router-link>
                  </template>
                  <div class="navbar-icons float-right">
                    <div class="navbar-contact float-left navbar-icon">
                      <button class="navbar-trigger show-for-md" @click="toContact">
                        <i class="iconfont svg-inline svg-inline--default">&#xe663;</i>
                        <i class="iconfont svg-inline svg-inline--transparent">&#xe663;</i>
                      </button>
                    </div>
                    <div class="navbar-search float-left navbar-icon">
                      <button class="navbar-trigger show-for-md" @click="showSearchLayer">
                        <svg
                          class="svg-inline svg-inline--default"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="20"
                          viewBox="0 0 18 17"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#000">
                            <path stroke-linecap="square" d="M17 17l-4-4" />
                            <circle cx="7.5" cy="7.5" r="7" />
                          </g>
                        </svg>
                        <svg
                          class="svg-inline svg-inline--transparent"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="20"
                          viewBox="0 0 18 17"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#FFF">
                            <path stroke-linecap="square" d="M17 17l-4-4" />
                            <circle cx="7.5" cy="7.5" r="7" />
                          </g>
                        </svg>
                      </button>
                    </div>
                    <div v-if="$route.name!='sustainability'" class="navbar-account float-left navbar-icon">
                      <button class="navbar-trigger" @click="toAccount">
                        <svg
                          class="svg-inline svg-inline--transparent"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="21"
                          viewBox="0 0 18 19"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#FFF" transform="translate(1)">
                            <path d="M16 19c0-4.418-3.582-7-8-7s-8 2.582-8 7" />
                            <circle cx="8" cy="5" r="4.5" />
                          </g>
                        </svg>
                        <svg
                          class="svg-inline svg-inline--default"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="21"
                          viewBox="0 0 18 19"
                        >
                          <g fill="none" fill-rule="evenodd" stroke="#000" transform="translate(1)">
                            <path d="M16 19c0-4.418-3.582-7-8-7s-8 2.582-8 7" />
                            <circle cx="8" cy="5" r="4.5" />
                          </g>
                        </svg>
                      </button>
                    </div>
                    <div v-if="$route.name!='sustainability'" class="navbar-minicart float-left navbar-icon">
                      <button class="navbar-trigger" @click="toCart">
                        <svg
                          class="svg-inline svg-inline--transparent"
                          aria-hidden="true"
                          version="1.1"
                          width="18"
                          height="26"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 32"
                          xml:space="preserve"
                        >
                          <g fill="none" stroke="#FFF" fill-rule="evenodd">
                            <g id="picto" transform="translate(0.000000, 5.000000)">
                              <g transform="translate(0.000000, 0.333333)">
                                <path
                                  id="Rectangle-2"
                                  d="M1.8,8.5L0.7,24.6c0,0,0,0.1,0,0.1c0,0.8,0.7,1.5,1.5,1.5h19.7c0,0,0.1,0,0.1,0 c0.8-0.1,1.4-0.8,1.4-1.6L22.2,8.5H1.8z"
                                />
                                <path id="Oval-Copy_1_" d="M17.2,11.3l0-5.7l0-0.8c-0.3-2.4-2.3-4.3-4.8-4.3S7.8,2.4,7.5,4.8l0,0.8v5.7" />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <svg
                          class="svg-inline svg-inline--default"
                          aria-hidden="true"
                          version="1.1"
                          width="18"
                          height="26"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 32"
                          xml:space="preserve"
                        >
                          <g fill="none" stroke="#000" fill-rule="evenodd">
                            <g id="picto" transform="translate(0.000000, 5.000000)">
                              <g transform="translate(0.000000, 0.333333)">
                                <path
                                  id="Rectangle-2"
                                  d="M1.8,8.5L0.7,24.6c0,0,0,0.1,0,0.1c0,0.8,0.7,1.5,1.5,1.5h19.7c0,0,0.1,0,0.1,0 c0.8-0.1,1.4-0.8,1.4-1.6L22.2,8.5H1.8z"
                                />
                                <path id="Oval-Copy_1_" d="M17.2,11.3l0-5.7l0-0.8c-0.3-2.4-2.3-4.3-4.8-4.3S7.8,2.4,7.5,4.8l0,0.8v5.7" />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <span class="navbar-minicart-quantity" v-if="cartTotal > 0">{{ cartTotal }}</span>
                      </button>
                    </div>
					<div v-if="$route.name=='sustainability'" class="navbar-minicart float-left navbar-icon">
					  <button class="navbar-trigger" @click="toStb('7')">
						  <img style="width: 30px;height: 30px;" src="@/assets/imgs/sustainability/quanpin.png" />
					  </button>
					</div>
					<div  v-if="$route.name=='sustainability'" class="navbar-minicart float-left navbar-icon">
					  <button class="navbar-trigger" @click="toStb('8')">
						  <img style="width: 22px;height: 30px;" src="@/assets/imgs/sustainability/pdf.png" /> 
						  
					  </button>
					</div>
					
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 移动端导航主体 -->
      <div class="mobile-menu-wrapper hide-for-md">
        <div class="mobile-menu">
          <div class="mobile-menu-header clearfix hide-for-md">
            <div class="mobile-header__club float-left">
              <div class="mobile-header__club-container">
                <div class="mobile-header__my-sisley-club-logo">
                  <router-link class="mobile-header__club-link c-element--not-accessible-while-hidden mobile-nav-close-trigger" to="/member-club">
                    <img class="svg-inline my-sisley-club-logo" src="@/assets/imgs/logos/sisley_club.svg" alt="My Sisley Club" />
                  </router-link>
                </div>
                <div class="mobile-header__club-description">
                  <p class="mobile-header__club-status mobile-header__club-status--user-not-logged">My Sisley Club</p>
                </div>
              </div>
            </div>
            <button type="button" class="mobile-header__close-btn float-right">
              <span class="button button--rounded">
                <svg
                  class="svg-inline cross"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="12px"
                  height="12px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                >
                  <g>
                    <g id="cross">
                      <g>
                        <polygon
                          points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            </button>
          </div>
          <div class="mobile-menu-group">
            <ul class="mobile-menu-first no-bullet clearfix">
              <li class="mobile-menu-item" v-for="(firstMenu, firstIndex) in navList" :key="`M-firstMenu_${firstIndex}`">
                <button class="mobile-menu-item-trigger mobile_nav_link" @click="mTriggerHandler($event, firstMenu.action)">{{ firstMenu.text }}</button>
                <template v-if="(firstMenu.children && firstMenu.children.length) || (firstMenu.banners && firstMenu.banners.children)">
                  <div class="mobile-dropdown-container delay-250 animated">
                    <div class="layout">
                      <div class="ms-row">
                        <div class="col-xs-12">
                          <ul class="mobile-menu-second no-bullet">
							  
                            <li class="mobile-menu-second-item mobile-menu-second-item__back-btn">
                              <a href="javascript:void(0);" class="mobile-menu-second-item__link mobile_nav_back_link" @click="mBackerHandler">返回</a>
                            </li>
                            <li class="mobile-menu-second-item">
                              <a
                                href="javascript:void(0);"
                                class="mobile-menu-second-item__link mobile_nav_link"
                                @click.prevent="mTriggerHandler($event, firstMenu.action)"
                                >{{ firstMenu.text }} - 查看全部</a
                              >
                            </li>
                            <template v-if="firstMenu.children && firstMenu.children.length">
                              <li
                                class="mobile-menu-second-item"
                                v-for="(secondaryMenu, secondaryIndex) in firstMenu.children"
                                :key="`M-secondaryMenu_${secondaryIndex}`"
                              >
                                <a
                                  href="javascript:void(0);"
                                  class="mobile-menu-second-item__link mobile_nav_link"
                                  @click.prevent="mTriggerHandler($event, secondaryMenu.action)"
                                  >{{ secondaryMenu.text }}</a
                                >
                                <ul class="mobile-menu-third no-bullet">
                                  <li class="mobile-menu-third-item mobile-menu-third-item__back-btn hide-for-md">
                                    <a href="javascript:void(0);" class="mobile-menu-third-item__link mobile_nav_back_link" @click="mBackerHandler">返回</a>
                                  </li>
                                  <li class="mobile-menu-third-item">
                                    <a
                                      href="/"
                                      class="mobile-menu-third-item__link mobile_nav_link"
                                      @click.prevent="mTriggerHandler($event, secondaryMenu.action)"
                                      >{{ secondaryMenu.text }} - 查看全部</a
                                    >
                                  </li>
                                  <template v-if="secondaryMenu.children && secondaryMenu.children.length">
                                    <li
                                      class="mobile-menu-third-item"
                                      v-for="(thirdMenu, thirdIndex) in secondaryMenu.children"
                                      :key="`M-thirdMenu_${thirdIndex}`"
                                    >
                                      <a
                                        href="/"
                                        class="mobile-menu-third-item__link mobile_nav_link"
                                        @click.prevent="mTriggerHandler($event, thirdMenu.action)"
                                        >{{ thirdMenu.text }}</a
                                      >
                                    </li>
									
                                  </template>
                                </ul>
                              </li>
                            </template>
                          </ul>
                          <template v-if="firstMenu.banners && firstMenu.banners.children">
                            <div class="dropdown-layer-content">
                              <template v-if="firstMenu.banners.type == 1">
                                <a
                                  class="mobile-dropdown-layer__content-item"
                                  href="/"
                                  @click.prevent="triggerHandler($event, banner.action)"
                                  v-for="(banner, idx) in firstMenu.banners.children"
                                  :key="`M-Menu_${firstIndex}-Banner_${idx}`"
                                >
                                  <div class="mobile-dropdown-layer__content-item-image">
                                    <img class="lazyloaded" :src="banner.src" :alt="banner.label" />
                                  </div>
                                  <div class="mobile-dropdown-layer__content-item-label">{{ banner.label }}</div>
                                </a>
                              </template>
                              <template v-if="firstMenu.banners.type == 2">
                                <a
                                  class="mobile-dropdown-layer__content-item"
                                  href="/"
                                  @click.prevent="triggerHandler($event, banner.action)"
                                  v-for="(banner, idx) in firstMenu.banners.children"
                                  :key="`M-Menu_${firstIndex}-Banner_${idx}`"
                                >
                                  <div class="mobile-dropdown-layer__content-item-image">
                                    <img :src="banner.src" :alt="banner.flag" />
                                  </div>
                                  <div class="mobile-dropdown-layer__content-item-flag" style="background-color: #000">{{ banner.flag }}</div>
                                  <div class="mobile-dropdown-layer__content-item-description">{{ banner.desc }}</div>
                                </a>
                              </template>
                              <template v-if="firstMenu.banners.type == 3">
                                <a
                                  class="mobile-dropdown-layer__content-item mobile-dropdown-layer__content-item--secondary"
                                  href="/"
                                  @click.prevent="triggerHandler($event, banner.action)"
                                  v-for="(banner, idx) in firstMenu.banners.children"
                                  :key="`M-Menu_${firstIndex}-Banner_${idx}`"
                                >
                                  <div class="mobile-dropdown-layer__image-wrapper">
                                    <img
                                      class="mobile-dropdown-layer__content-item-image lazyloaded"
                                      :srcset="`${banner.srcset || banner.src} 2x`"
                                      :src="banner.src"
                                      :alt="banner.subtitle"
                                    />
                                  </div>
                                  <div class="mobile-dropdown-layer__content-item-subtitle heading-h4">{{ banner.subtitle }}</div>
                                  <div class="mobile-dropdown-layer__content-item-description">{{ banner.desc }}</div>
                                </a>
                              </template>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </li>
			  <!-- <li class="mobile-menu-item" >
				  <button @click="toSustainability2()" class="mobile-menu-item-trigger mobile_nav_link">品牌故事</button>
			  </li> -->
              <li class="mobile-menu-item">
                <template v-if="!isMaster">
                  <router-link to="/" class="mobile-menu-item__loggle">
                    <img class="svg-inline svg-inline--default" src="@/assets/imgs/logos/sisley-logo_black.svg" alt="Sisley Paris" />
                  </router-link>
                </template>
                <template v-else>
                  <router-link to="/hair-rituel" class="mobile-menu-item__loggle">
                    <img class="svg-inline svg-inline--default" src="@/assets/imgs/logos/hair_rituel-logo_black.svg" alt="Hair Rituel" />
                  </router-link>
                </template>
              </li>
              <li class="mobile-menu-item">
                <div class="mobile-toolbar-items">
                  <div class="content-asset">
                    <div class="layout">
                      <div class="ms-row">
                        <div class="col-xs-12 col-md-56">
                          <ul class="no-bullet">
                            <li class="mobile-toolbar__item">
                              <div to="/groupe" class="mobile-toolbar__item-link" target="_blank" rel="nofollow">公司</div>
                            </li>
                            <li class="mobile-toolbar__item">
                              <div to="/fondation" class="mobile-toolbar__item-link" target="_blank" rel="nofollow">慈善</div>
                            </li>
                            <li class="mobile-toolbar__item">
                              <div to="/" class="mobile-toolbar__item-link" target="_blank" rel="nofollow">我们的专长</div>
                            </li>
                          </ul>
                        </div>
                        <!-- <div class="col-xs-12 col-md-65 text--right">
                          <ul class="no-bullet">
                            <li class="mobile-toolbar__item">
                              <a href="/contact" class="mobile-toolbar__item-link" target="_blank" rel="nofollow">Service clients</a>
                            </li>
                          </ul>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </li>
			  
            </ul>
          </div>
        </div>
      </div>
      <!-- 移动端导航遮罩层 -->
      <div class="mobile-menu-mask"></div>
    </div>
    <!-- 搜索框 -->
    <div :class="['search-wrapper', enableSearch ? 'fadeInHeight' : '']">
      <div class="search-container animatedParent">
        <button :class="['search__close-button', 'show-for-md', 'animated', 'delay-500', enableSearch ? 'fadeIn' : '']" @click="hideSearchLayer">
          <svg
            class="svg-inline cross"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="12px"
            height="12px"
            viewBox="0 0 612 612"
            style="enable-background:new 0 0 612 612;"
            xml:space="preserve"
          >
            <g>
              <g id="cross">
                <g>
                  <polygon
                    points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011"
                  />
                </g>
              </g>
            </g>
          </svg>
          <svg
            class="svg-inline cross-inverted"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="8px"
            height="8px"
            viewBox="0 0 612 612"
            style="enable-background:new 0 0 612 612;"
            xml:space="preserve"
          >
            <g>
              <g id="cross">
                <g>
                  <polygon
                    style="fill:#fff;"
                    points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011"
                  />
                </g>
              </g>
            </g>
          </svg>
        </button>
        <div class="ms-row">
          <Search v-if="enableSearch" :showNoticeBar="showNoticeBar" @hideSearchLayer="hideSearchLayer"></Search>
        </div>
        <div class="suggestions-wrapper"></div>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div :class="['mask', enableSearch ? 'show search' : enableMask ? 'show' : '']"></div>
  </header>
</template>

<script>
import actionMixins from '@/utils/action.mixins'
import api from '@/utils/api'
import types from '@/store/types'
import utils from '@/utils'
import Search from '@/components/Search'
import md5 from 'md5';
export default {
  name: 'XHeader',
  mixins: [actionMixins],
  components: { Search },
  data() {
    return {
      menu: null,
      enableMask: false,
      fixed: false
    }
  },
  created() {
    this.loadSource()
    // 已登录
    if (this.isLogin) {
      // 无用户信息
      !this.userInfo && this.$store.dispatch(types.GET_PROFILE)
      // 无收藏信息
      this.$store.state?.favPids?.length < 1 && this.$store.dispatch(types.FAV_PIDS_LIST)
    }
    this.$store.dispatch(types.CART_GET)
    // 获取导航颜色和购物车文案
    this.siteConfig()
  },
  mounted() {},
  methods: {
    loadSource() {
      Promise.all([api.ajax4Page(types.$CMP_MENU_PRIMARY), api.ajax4Page(types.$CMP_MENU_SECONDARY)])
        .then((res) => {
          let [primary, secondary] = res
          let payload = {}
          primary && (payload.primary = primary.nodes)
          secondary && (payload.secondary = secondary.nodes)
          //
          this.$store.commit('saveNavList', payload)
          //
          this.$nextTick(() => {
            this.init()
          })
        })
        .catch((err) => {
          console.warn(err)
        })
    },
    siteConfig(){
      api[types.SITE_CONFIG]({}).then(res => {
        this.$store.commit('siteConfig', res.data);
      })
    },
    init() {
      // 定位
      var toolbar = document.querySelector('.navbar')
      // var menuWrapper = document.querySelector('.menu-wrapper')
      // var notice = document.querySelector('.notice')
      if (!toolbar) {
        return
      }
      var io = new IntersectionObserver(
        (entries) => {
          let ratio = entries[0].intersectionRatio
          if (ratio === 0) {
            this.fixed = true
            // menuWrapper.classList.add('fixed')
            // notice.classList.add('fixed')
          } else {
            this.fixed = false
            // menuWrapper.classList.remove('fixed')
            // notice.classList.remove('fixed')
          }
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: [0, 0.01],
        }
      )
      io.observe(toolbar)
      // 移动端导航显示隐藏处理
      let toggler = document.querySelector('.navbar-toggler')
      toggler.addEventListener('click', this.openMobileMenu, false)
      let closer = document.querySelector('.mobile-header__close-btn')
      closer.addEventListener('click', this.closeMobileMenu, false)
    },
    // 菜单项
    onMenuItemFocus() {
      this.enableMask = true
    },
    // 菜单项
    onMenuItemBlur() {
      this.enableMask = false
    },
    // 菜单项点击处理：跳转链接+关闭移动端导航
    triggerHandler(evt, action) {
      this.actionHandler(action)
      this.closeMobileMenu()
    },
    // 打开移动端导航
    openMobileMenu() {
      let doc = document.documentElement
      let navbarWrapper = document.querySelector('.navbar-wrapper')
      let mobileMenuWrapper = document.querySelector('.mobile-menu-wrapper')
      let mobileMenuMask = document.querySelector('.mobile-menu-mask')
      if (mobileMenuWrapper.classList.contains('in')) {
        mobileMenuWrapper.classList.remove('in')
        doc.classList.remove('js-no-scroll')
        navbarWrapper.style.removeProperty('max-width')
        mobileMenuMask.classList.remove('show')
      } else {
        mobileMenuMask.classList.add('show')
        navbarWrapper.style.setProperty('max-width', document.body.clientWidth + 'px')
        mobileMenuWrapper.classList.add('in')
        doc.classList.add('js-no-scroll')
      }
    },
    // 关闭移动端导航
    closeMobileMenu() {
      let doc = document.documentElement
      let navbarWrapper = document.querySelector('.navbar-wrapper')
      let mobileMenuWrapper = document.querySelector('.mobile-menu-wrapper')
      let mobileMenuList = document.querySelector('.mobile-menu-first')
      let mobileMenuMask = document.querySelector('.mobile-menu-mask')
      mobileMenuWrapper.classList.remove('in')
      mobileMenuList.classList.remove('second-level', 'third-level')
      doc.classList.remove('js-no-scroll')
      navbarWrapper.style.removeProperty('max-width')
      mobileMenuMask.classList.remove('show')
    },
    // 移动端导航进入处理
    mTriggerHandler(evt, action) {
      let mobileMenuList = document.querySelector('.mobile-menu-first')
      let mobileToolbarItems = document.querySelector('.mobile-toolbar-items')
      let mobileMenuDropdown = document.querySelectorAll('.mobile-dropdown-container')
      let mobileThirdMenus = document.querySelectorAll('.mobile-menu-third')
      let dom = evt.target || evt.srcElement
      if (dom.nextElementSibling) {
        mobileToolbarItems.style.setProperty('display', 'none')
        let owner = utils.closest(dom, 'ul')
        if (owner.classList.contains('mobile-menu-first')) {
          mobileMenuList.classList.add('second-level')
          mobileMenuDropdown.forEach((dropdown) => dropdown.classList.remove('show'))
          dom.nextElementSibling.classList.add('show')
        } else if (owner.classList.contains('mobile-menu-second')) {
          mobileMenuList.classList.add('third-level')
          mobileThirdMenus.forEach((menu) => menu.classList.remove('show'))
          dom.nextElementSibling.classList.add('show')
        } else {
          console.warn(dom, owner)
        }
      } else {
        // console.info("直接访问", action, dom.getAttribute("href"));
        this.triggerHandler(evt, action)
      }
    },
    // 移动端导航退出处理
    mBackerHandler(evt) {
      let mobileMenuList = document.querySelector('.mobile-menu-first')
      let mobileToolbarItems = document.querySelector('.mobile-toolbar-items') // 一级菜单中的底部项
      let dom = evt.target || evt.srcElement
      let owner = utils.closest(dom, 'ul')
      if (owner.classList.contains('mobile-menu-third')) {
        mobileMenuList.classList.remove('third-level')
        owner.classList.remove('show')
      } else if (owner.classList.contains('mobile-menu-second')) {
        mobileMenuList.classList.remove('second-level')
        let domParents = utils.closest(dom, '.mobile-dropdown-container')
        domParents && domParents.classList.remove('show')
        mobileToolbarItems.style.removeProperty('display')
      } else {
        console.warn(dom, owner)
      }
    },
    // 新开客服窗口
    toContact() {
		// 七鱼
		console.log(this.$toysf,"客服2")
		this.$toysf(2)
		return;
      // window.open('https://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=1441890&configID=154108&jid=5859433606&s=1', '_blank')
      window.open(`https://care60.live800.com/live800/chatClient/chatbox.jsp?companyID=80012804&configID=2576&codeType=custom`, '_blank')
      return
      // 集团版
      if(this.userInfo) {
        let userId = this.userInfo.id.toString()
        let name = this.userInfo.id.toString()
        let timestamp = new Date().getTime()
        let key = 'sisley'
        let hashCode = md5(encodeURIComponent(userId+name+timestamp+key).toUpperCase()).toUpperCase()
        let info = encodeURIComponent(`userId=${userId}&name=${name}&timestamp=${timestamp}&hashCode=${hashCode}`)
        window.open(`https://care60.live800.com/live800/chatClient/chatbox.jsp?companyID=80012804&configID=2576&codeType=custom&info=${info}`, '_blank')
      } else {
        this.$store.commit("toggleLogin", true);
      }
    },
    // 显示搜索
    showSearchLayer() {
		if(this.$route.name=='sustainability'){
			this.toStb('9')
		}else{
			this.$store.commit('toggleSearch', true)
		}
      
    },
    // 隐藏搜索
    hideSearchLayer() {
      this.$store.commit('toggleSearch', false)
    },
    toSearch() {},
    // 进个人中心(此处不做登录判断，路由管理中统一处理)
    toAccount() {
      this.$router.push({ name: 'Myaccount' })
      this.hideSearchLayer()
    },
    toCart() {
      if(window.innerWidth > 1024) {
        this.$store.commit('toggleMiniCar', true)
      } else {
        this.$router.push({ path: '/cart' })
      }
      this.hideSearchLayer()
    },
    toExpandMenu() {
      this.hideSearchLayer()
    },
    // 导航悬浮时移除透明背景、字体颜色等样式
    onMenuFocus(evt) {
      // if (this.enableFloating) {
      let dom = evt.target || evt.srcElement
      dom.parentElement.classList.add('no-transparent')
      // }
    },
    // 导航悬浮时还原透明背景、字体颜色等样式
    onMenuBlur(evt) {
      // if (this.enableFloating) {
      let dom = evt.target || evt.srcElement
      dom.parentElement.classList.remove('no-transparent')
      // }
    },
    hideNoticeBar() {
      this.notice.status = 0;
    },
	/** sustainability 滚动到指定页面 */
	toStb(i){
		this.$store.commit('toSustainability',i)
	},
	toSustainability2(){
		this.$router.push('/sustainabilityView')
		this.closeMobileMenu()
	}
  },
  computed: {
    isMaster() {
      return this.$store.state.isMaster
    },
    navList() {
      return this.$store.getters.navList
    },
    enableFloating() {
      return this.$store.state.enableFloating
    },
    enableSearch() {
      return this.$store.state.enableSearch
    },
    isLogin() {
      return this.$store.state.isLogin
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    cartTotal() {
      if (this.$store.state?.cartInfo?.goods_list?.goods?.length) {
        return this.$store.state.cartInfo.goods_list.goods.reduce((outerPrevious, outerCurrent) => {
          if (Array.isArray(outerCurrent.main)) {
            return (
              outerPrevious +
              outerCurrent.main.reduce((innerPrevious, innerCurrent) => {
                return innerPrevious + parseInt(innerCurrent.qty || innerCurrent.quantity)
              }, 0)
            )
          } else {
            return outerPrevious + parseInt(outerCurrent.qty || outerCurrent.quantity)
          }
        }, 0)
      }
      return 0
    },
    // 公告内容
    notice() {
      if(this.$store.state?.notice) {
        if(utils.isMobile()) {
          return this.$store.state?.notice?.h5.bar;
        }else {
          return this.$store.state?.notice?.pc.bar;
        }
      }
    },
    showNoticeBar() {
      if (this.notice && this.notice.status == 1) {
        return true;
      } else {
        return false;
      }
    },
    siteConfigColor() {
      if(this.$route.meta && this.$route.meta.menuThem) {
        return this.$route.meta.menuThem
      } else {
        return this.$store.state?.theme || this.$store.state?.siteConfig?.BANNER_NAV_INDICATOR?.color;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-trigger {
  position: relative;
  z-index: 0;
  cursor: pointer;
  i.iconfont {
    font-size: 18px;
  }
}
.navbar-trigger:hover:after {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: '';
  width: 2.8125rem;
  height: 2.8125rem;
  background-color: #f5f5f5;
  border-radius: 50%;
  z-index: -1;
  transition: all 0.2s linear;
}
.header .header-wrapper .x-wrapper .menubar .menu-wrapper .navbar-icons .navbar-contact .navbar-trigger:hover:after {
  top: 60%;
}
.header .header-wrapper .x-wrapper .menubar .menu-wrapper .navbar-icons .navbar-minicart .navbar-trigger:hover:after {
  top: 56%;
}
.header .header-wrapper .x-wrapper .navbar .navbar-wrapper .navbar-minicart .navbar-trigger:hover:after {
  top: 56%;
}

.color--pirate-gold {
  color: #b28200;
}
//
.header {
  height: 63px;
  .header-wrapper {
    position: relative;
    z-index: 11;
    // 公告
    .notice {
      width: 100%;
      padding: 0 17px;
      height: 59px;
      background: #000;
      color: #ffffff;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      p { margin-bottom: 0; }
      p, p a, p span, p a span {
        font-size: 14px; color: #FFF; font-family: HelveticaNeueLTW05-45Light,Avenir,Helvetica,Arial,sans-serif;
        text-decoration: none;
        &.gg_link { text-decoration: underline; }
      }
      .icon-close {
        width: 25px;
        height: 25px;
        color: #000;
        text-align: center;
        cursor: pointer;
      }
    }
    // 工具栏
    .toolbar {
      padding: 1.125rem 1.875rem 6.5625rem;
      background-color: #000;
      .toolbar-items {
        .toolbar-item {
          display: inline-block;
          padding: 0 0.625rem;
          &:first-of-type {
            padding-left: 0;
          }
          &:last-of-type {
            padding-right: 0;
          }
          .toolbar-item-link {
            font-size: 0.6875rem;
            color: #ffffff;
            text-decoration: none;
          }
        }
      }
    }
    // 主体部分
    .x-wrapper {
      background-color: #ffffff;
      // 导航栏
      .navbar {
        .navbar-wrapper {
          position: fixed;
          top: 0;
          width: 100%;
          padding: 0.0625rem 1.0625rem;
          background: #ffffff;
          .header__logo {
            float: left;
            padding: 1.3125rem 0 0.9375rem;
          }
          .sisley-club {
            display: flex;
            align-items: center;
            float: left;
            .club-link {
              .svg-inline {
                width: 2.625rem;
                height: 3.25rem;
                float: left;
              }
            }
            .club-desc {
              padding: 0.125rem 0 0 0.5625rem;
              font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
              line-height: 1.25;
              color: #575757;
              .club-title {
                margin-top: -0.5rem;
                font-size: 0.875rem;
                line-height: 1.6;
                font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                margin-bottom: 0;
              }
            }
          }
          .navbar-contact {
            position: relative;
            padding: 1.4375rem 0.625rem 0;
            background-color: transparent;
            .iconfont.svg-inline--default {
              color: #000;
            }
            .iconfont.svg-inline--transparent {
              color: #fff;
            }
          }
          .navbar-search {
            position: relative;
            padding: 1.4375rem 0.625rem 0;
            background-color: transparent;
          }
          .navbar-account {
            position: relative;
            padding: 1.375rem 0.625rem 0;
          }
          .navbar-minicart {
            position: relative;
            padding: 1.125rem 1.25rem 0 0.625rem;
            .navbar-trigger {
              position: relative;
            }
            .navbar-minicart-quantity {
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              right: -0.875rem;
              top: -0.25rem;
              background-color: #000;
              width: 1.25rem;
              height: 1.25rem;
              border-radius: 50%;
              color: #fff;
              font-size: 0.625rem;
              text-align: center;
            }
          }
          .navbar-toggler {
            padding: 1.625rem 0.5rem 1.5rem 0.5rem;
            cursor: pointer;
            line-height: 1.15;
          }
          &.has-notice {
            top: 59px;
          }
        }
      }
      // 菜单栏
      .menubar {
        position: relative;
        right: auto;
        top: auto;
        width: 100%;
        height: 54px;
        padding: 0;
        z-index: auto;
        background-color: transparent;
        transition: right 1s cubic-bezier(0.77, 0, 0.175, 1);
        .menu-wrapper {
          &.fixed.has-notice {
            top: 59px;
          }
          .menu-container {
            display: block;
            margin-top: 1.25rem;
            .menu-list {
              .menu-item {
                padding: 0 2.375rem 0 0;
                float: left;
                .menu-item-link {
                  display: block;
                  width: 100%;
                  position: relative;
                  font-size: 0.8125rem;
                  padding: 0;
                  margin: 0 0 1.25rem;
                  line-height: 1.15;
                  cursor: pointer;
                  font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                  color: #000;
                  text-decoration: none;
                  text-transform: uppercase;
                  text-align: left;
                  &:before {
                    content: '';
                    position: absolute;
                    left: 50%;
                    bottom: -0.125rem;
                    width: 0;
                    height: 0.0625rem;
                    background-color: #000;
                    transform: translateX(-50%);
                    transition: width 0.2s linear;
                  }
                  &:hover:before {
                    width: 100%;
                  }
                }
                // 二级 & 三级菜单
                .dropdown-container {
                  position: absolute;
                  left: 0;
                  top: 100%;
                  z-index: auto;
                  width: 100%;
                  background-color: #fff;
                  visibility: hidden;
                  pointer-events: none;
                  .dropdown-menu {
                    display: flex;
                    padding: 2.1875rem 0;
                    list-style-type: none;
                    .dropdown-item {
                      float: none;
                      width: 12.625rem;
                      padding: 0 0.9375rem 0 0;
                      .nav-link {
                        display: block;
                        position: relative;
                        width: 100%;
                        padding: 1.375rem 4.0625rem 1.375rem 2.0625rem;
                        font-size: 0.8125rem;
                        color: #000;
                        font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                        text-decoration: none;
                        text-transform: uppercase;
                        text-align: left;
                        &:hover {
                          text-decoration: underline;
                        }
                        &.nav-link--secondary {
                          font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                          font-size: 0.75rem;
                          letter-spacing: 0.0625rem;
                          padding: 0 0 1.25rem;
                          padding-bottom: 0.9375rem;
                          z-index: 1;
                          border-bottom: none;
                        }
                        &.nav-link--third {
                          padding: 0 0 1.25rem;
                          padding-bottom: 0;
                          z-index: 1;
                          font-size: 0.8125rem;
                          color: #575757;
                          text-transform: none;
                          border-bottom: none;
                        }
                      }
                      .dropdown-submenu {
                        display: block;
                        background-color: #fff;
                        z-index: auto;
                        padding-bottom: 0;
                        list-style-type: none;
                        margin-top: 1rem;
                        .dropdown-submenu-item {
                          float: none;
                          padding: 0;
                        }
                      }
                    }
                  }
                  .dropdown-layer {
                    display: flex;
                    .dropdown-layer-item {
                      text-decoration: none;
                      position: relative;
                      display: block;
                      margin: 2.1875rem 0.9375rem 2.1875rem 0;
                      max-width: 37rem;
                      margin-top: 0;
                      font-size: 0.75rem;
                      &:last-of-type {
                        margin-right: 0;
                      }
                      .dropdown-layer-item-image-wrapper {
                        .dropdown-layer-item-image {
                          vertical-align: middle;
                          max-width: 100%;
                          width: 100%;
                        }
                      }
                      .dropdown-layer-item-subtitle {
                        margin-bottom: 0.625rem;
                      }
                      .dropdown-layer-item-label {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        padding: 0.125rem 0.625rem;
                        background-color: #fff;
                        font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                        font-size: 0.6875rem;
                        color: #575757;
                        letter-spacing: 0.0625rem;
                      }
                      .dropdown-layer-item-flag {
                        position: absolute;
                        top: 1.25rem;
                        left: -0.625rem;
                        padding: 0.1875rem 0.625rem;
                        background-color: #000;
                        font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                        font-size: 0.75rem;
                        color: #fff;
                        letter-spacing: 0.0625rem;
                      }
                      .dropdown-layer-item-desc {
                        max-width: 24.375rem;
                        padding-top: 0.8125rem;
                        font-size: 0.875rem;
                        font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                        color: #575757;
                      }
                    }
                    .col-md-3 {
                      .dropdown-layer-item {
                        margin: 0 0 2.1875rem 0;
                        .dropdown-layer-item-image-wrapper {
                          padding-bottom: 1.0625rem;
                        }
                        .dropdown-layer-item-desc {
                          padding-top: 0;
                          font-size: 0.8125rem;
                        }
                      }
                    }
                  }
                }
                &:hover .dropdown-container {
                  visibility: visible;
                  pointer-events: auto;
                  opacity: 0;
                  transform: translateY(-20px);
                  animation-name: fadeInDownShort;
                }
              }
            }
          }
          .menu-logo--large {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 1;
            width: 7.875rem;
            height: 3.1875rem;
            border: 0.0625rem solid #dfdfdf;
            border-radius: 1.6875rem;
            text-align: center;
            margin: 0;
            transition: all 0.2s linear;
            &:hover {
              background-color: #000;
              border: 0.0625rem solid #000;
              .logo-small {
                display: none;
              }
              .logo-small__white {
                display: inline;
              }
            }
          }
          .navbar-icons {
            display: none;
            padding: 0.9375rem 0;
            .navbar-contact {
              position: relative;
              padding: 0.625rem 0.9375rem;
              background-color: transparent;
            }
            .navbar-search {
              position: relative;
              padding: 0.625rem 0.9375rem;
              background-color: transparent;
            }
            .navbar-account {
              position: relative;
              padding: 0.5625rem 0.9375rem 0.3125rem;
            }
            .navbar-minicart {
              position: relative;
              padding: 0.3125rem 0.875rem 0.3125rem 0.9375rem;
              .navbar-trigger {
                position: relative;
              }
              .navbar-minicart-quantity {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: -0.875rem;
                top: -0.25rem;
                background-color: #000;
                width: 1.25rem;
                height: 1.25rem;
                border-radius: 50%;
                color: #fff !important;
                font-size: 0.625rem;
                text-align: center;
              }
            }
          }
          // Fixed 定位
          &.fixed {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 70px;
            padding: 0 1rem;
            background-color: #ffffff;
            .menu-container {
              margin-top: 1.5625rem;
              .menu-list {
                .menu-item {
                  .menu-item-link {
                    margin-bottom: 2rem;
                  }
                }
              }
            }
            .menu-logo--large {
              display: none;
            }
            .navbar-icons {
              display: block;
            }
          }
        }
      }
    }
    // 移动端导航主体
    .mobile-menu-wrapper {
      position: fixed;
      top: 0;
      right: -100%;
      z-index: 11;
      width: 100%;
      transition: right 1s cubic-bezier(0.77, 0, 0.175, 1);
      &.in {
        right: 0;
      }
      .mobile-menu {
        width: 80%;
        margin-left: 20%;
        background-color: #ffffff;
        .mobile-menu-header {
          .mobile-header__club {
            padding: 1.75rem 0 2.125rem 2.0625rem;
            .mobile-header__club-container {
              display: flex;
              align-items: center;
              .mobile-header__my-sisley-club-logo {
                float: left;
                .mobile-header__club-link {
                  display: flex;
                  text-decoration: none;
                  .svg-inline {
                    width: 2.625rem;
                    height: 3.25rem;
                    float: left;
                  }
                }
              }
              .mobile-header__club-description {
                float: left;
                padding: 0.125rem 0 0 0.5625rem;
                line-height: 1.25;
                color: #575757;
                font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                .mobile-header__club-status {
                  font-size: 0.875rem;
                  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                  line-height: 1.6;
                  margin-bottom: 0;
                }
                .mobile-header__club-status--user-not-logged {
                  white-space: nowrap;
                  margin-top: -0.5rem;
                }
              }
            }
          }
          .mobile-header__close-btn {
            padding: 2.1875rem 1.375rem 1.5625rem 0;
            .button {
              display: inline-block;
              vertical-align: middle;
              padding: 0.8125rem 1.875rem;
              -webkit-appearance: none;
              border-radius: 1.375rem;
              text-transform: uppercase;
              font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
              font-size: 0.625rem;
              color: #000;
              line-height: 1;
              letter-spacing: 0.0625rem;
              text-align: center;
              cursor: pointer;
              transition: background-color 0.25s ease-out, color 0.25s ease-out;
              border: 0.0625rem solid #cacaca;
              background: transparent;
              text-decoration: none;
              &.button--rounded {
                width: 2.375rem;
                height: 2.375rem;
                position: relative;
                border-radius: 50%;
                padding: 0;
                background: transparent;
                border-color: #cacaca;
                color: #000;
              }
            }
            .button.button--rounded .svg-inline,
            .button.button--rounded img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              display: block;
            }
          }
        }
        .mobile-menu-group {
          .mobile-menu-first {
            .mobile-menu-item {
              .mobile-menu-item-trigger {
                display: block;
                position: relative;
                width: 100%;
                padding: 1.375rem 4.0625rem 1.375rem 2.0625rem;
                text-align: left;
                line-height: 1;
                font-size: 0.8125rem;
                font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                color: #000;
                text-decoration: none;
                text-transform: uppercase;
                &:hover {
                  cursor: pointer;
                }
                &:after {
                  content: '';
                  background: url(../assets/imgs/icons/arrow-big.svg) no-repeat;
                  width: 0.875rem;
                  height: 0.875rem;
                  position: absolute;
                  right: 2rem;
                  top: 37%;
                  transform: rotate(270deg);
                }
              }
              .mobile-dropdown-container {
                position: absolute;
                top: 0;
                left: 100%;
                width: 100%;
                padding-bottom: 5.3125rem;
                display: none;
                .mobile-menu-second {
                  padding-bottom: 1.25rem;
                  padding-top: 5.125rem;
                  .mobile-menu-second-item {
                    .mobile-menu-second-item__link {
                      display: block;
                      width: 100%;
                      position: relative;
                      padding: 1.375rem 4.0625rem 1.375rem 2.0625rem;
                      font-size: 0.8125rem;
                      font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                      color: #000;
                      text-decoration: none;
                      text-transform: uppercase;
                      text-align: left;
                      &:after {
                        content: '';
                        background: url(../assets/imgs/icons/arrow-big.svg) no-repeat;
                        width: 0.875rem;
                        height: 0.875rem;
                        position: absolute;
                        right: 2rem;
                        top: 37%;
                        transform: rotate(270deg);
                      }
                    }
                    &.mobile-menu-second-item__back-btn {
                      position: fixed;
                      width: 80%;
                      height: 5.125rem;
                      top: 7.125rem;
                      right: 0;
                      z-index: 1;
                      padding: 0;
                      & > .mobile-menu-second-item__link {
                        background-color: #f3f3f3;
                        font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                        font-size: 0.6875rem;
                        letter-spacing: 0.0625rem;
                        padding-left: 3.4375rem;
                        margin-bottom: 1.25rem;
                        cursor: pointer;
                        &:after {
                          right: auto;
                          left: 1.9375rem;
                          transform: rotate(90deg);
                        }
                      }
                    }
                    .mobile-menu-third {
                      position: absolute;
                      top: 0;
                      left: 100%;
                      width: 100%;
                      padding-bottom: 1.25rem;
                      padding-top: 5.125rem;
                      display: none;
                      .mobile-menu-third-item {
                        .mobile-menu-third-item__link {
                          display: block;
                          width: 100%;
                          position: relative;
                          padding: 1.375rem 4.0625rem 1.375rem 2.0625rem;
                          font-size: 0.8125rem;
                          font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                          color: #000;
                          text-decoration: none;
                          text-transform: uppercase;
                          text-align: left;
                          &:after {
                            content: '';
                            background: url(../assets/imgs/icons/arrow-big.svg) no-repeat;
                            width: 0.875rem;
                            height: 0.875rem;
                            position: absolute;
                            right: 2rem;
                            top: 37%;
                            transform: rotate(270deg);
                          }
                        }
                        &.mobile-menu-third-item__back-btn {
                          position: fixed;
                          width: 80%;
                          height: 5.125rem;
                          top: 7.125rem;
                          right: 0;
                          z-index: 1;
                          padding: 0;
                          & > .mobile-menu-third-item__link {
                            background-color: #f3f3f3;
                            font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                            font-size: 0.6875rem;
                            letter-spacing: 0.0625rem;
                            padding-left: 3.4375rem;
                            margin-bottom: 1.25rem;
                            cursor: pointer;
                            &:after {
                              right: auto;
                              left: 1.9375rem;
                              transform: rotate(90deg);
                            }
                          }
                        }
                      }
                      &.show {
                        display: block;
                      }
                    }
                  }
                }
                .dropdown-layer-content {
                  .mobile-dropdown-layer__content-item {
                    margin: 1.25rem 1rem;
                    text-decoration: none;
                    position: relative;
                    display: block;
                    .mobile-dropdown-layer__content-item-image {
                      position: relative;
                    }
                    .mobile-dropdown-layer__content-item-label {
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      padding: 0.125rem 0.625rem;
                      background-color: #fff;
                      font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                      font-size: 0.6875rem;
                      color: #575757;
                      letter-spacing: 0.0625rem;
                    }
                    .mobile-dropdown-layer__content-item-flag {
                      background-color: #b28200;
                      position: absolute;
                      top: 0.625rem;
                      left: -0.625rem;
                      padding: 0.1875rem 0.625rem;
                      font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
                      font-size: 0.75rem;
                      color: #fff;
                      letter-spacing: 0.0625rem;
                    }
                    .mobile-dropdown-layer__content-item-description {
                      padding-top: 0.8125rem;
                      font-size: 0.875rem;
                      font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                      color: #575757;
                      max-width: 24.375rem;
                    }
                    &.mobile-dropdown-layer__content-item--secondary {
                      margin: 0 0 2.1875rem 2.0625rem;
                      .mobile-dropdown-layer__image-wrapper {
                        position: relative;
                        padding-bottom: 1.0625rem;
                        .mobile-dropdown-layer__content-item-image {
                          width: 100%;
                        }
                      }
                      .mobile-dropdown-layer__content-item-description {
                        font-size: 0.8125rem;
                        padding-top: 0;
                      }
                    }
                  }
                }
              }
              .mobile-menu-item__loggle {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 7.875rem;
                height: 3.1875rem;
                margin: 1.25rem 2.0625rem 2.5rem;
                border: 0.0625rem solid #dfdfdf;
                border-radius: 1.6875rem;
                text-align: center;
              }
              .mobile-toolbar-items {
                background-color: #000;
                padding: 1.125rem 1.875rem 6.5625rem;
                .mobile-toolbar__item {
                  display: block;
                  padding: 0;
                  text-align: left;
                  .mobile-toolbar__item-link {
                    font-size: 0.75rem;
                    font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                    color: #fff !important;
                    text-decoration: none;
                    display: block;
                    padding: 1rem 0;
                  }
                }
              }
            }
            &.second-level {
              left: -100%;
              .mobile-dropdown-container {
                &.show {
                  display: block;
                }
              }
            }
            &.third-level {
              left: -200%;
            }
          }
        }
      }
    }
    .mobile-menu-mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      background-color: rgba(0, 0, 0, 0.5);
      display: none;
      &.show {
        display: block;
      }
    }
  }
  .search-wrapper {
    height: 0;
    overflow: hidden;
    transition: all 0.5s ease-in;
    .search-container {
      .search__close-button {
        display: inline-block;
        vertical-align: middle;
        transition: background-color 0.25s ease-out, color 0.25s ease-out;
        font-size: 0.75rem;
        font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
        color: #000;
        line-height: 1;
        letter-spacing: 0.0625rem;
        text-align: center;
        cursor: pointer;
        text-decoration: none;
        text-transform: uppercase;
        border: 0.0625rem solid #cacaca;
        border-radius: 50%;
        background: transparent;
        width: 2.375rem;
        height: 2.375rem;
        padding: 0;
        .svg-inline,
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: block;
        }
        .cross-inverted {
          visibility: hidden;
          width: 0.75rem;
          height: 0.75rem;
        }
        &:hover {
          text-decoration: none;
          background-color: #000;
          border-color: #000;
          color: #000;
          outline: none;
          .cross {
            visibility: hidden;
          }
          .cross-inverted {
            visibility: visible;
            transform: translate(-50%, -50%) rotate(180deg);
            transition: all 0.2s linear;
          }
        }
      }
      .navigation-bar__search {
        background-color: #f5f5f5;
        transition: top 0.2s;
        .navigation-bar__search-form {
          margin: 0.75rem 1.0625rem;
          .search-trigger {
            position: absolute;
            left: 1rem;
            top: 0.75rem;
            padding: 0;
            cursor: pointer;
          }
          .search-field {
            font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
            font-size: 1rem;
            text-indent: 2.625rem;
            width: 100%;
            height: 2.5rem;
            padding-right: 2.625rem;
            border: none;
            border-radius: 1.25rem;
            background-color: #fff;
            &:focus {
              outline: -webkit-focus-ring-color auto 1px;
            }
            &::placeholder,
            &:-moz-placeholder,
            &::-moz-placeholder,
            &::-ms-input-placeholder,
            &::-webkit-input-placeholder {
              color: #cacaca;
            }
          }
          .search-clear {
            position: absolute;
            right: 0.0625rem;
            top: 0.1875rem;
            padding: 0.0625rem 0.9375rem 0.625rem;
            font-size: 1.625rem;
            cursor: pointer;
            line-height: 1;
          }
        }
      }
      .results-container {
        position: fixed;
        top: 7.9375rem;
        z-index: 12;
        background-color: #fff;
        overflow-y: auto;
        display: none;
        width: 100%;
        height: 100vh;
        max-height: calc(100vh - 7.9375rem);
        padding: 1.875rem 1.0625rem 5.9375rem;
        .search-suggestions {
          margin-bottom: 2.5rem;
          .search-suggestions__title {
            margin-bottom: 1.6875rem;
          }
          .search-suggestions__list {
            .search-suggestions__item {
              .search-suggestions__link {
                text-decoration: none;
                font-size: 0.75rem;
                font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
                color: #575757;
                line-height: 2.25rem;
                &.color--pirate-gold {
                  color: #b28200;
                }
              }
            }
          }
        }
        &.active {
          display: block;
        }
      }
    }
    &.fadeInHeight {
      height: 680px;
      .navigation-bar__search {
        width: 100%;
        position: fixed;
        top: 63px;
        left: 0;
        z-index: 11;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    &.show {
      display: block;
    }
    &.search {
      z-index: 11;
    }
  }
}

@media only screen and (max-width: 23.4375em) {
  .header .header-wrapper .x-wrapper .navbar .navbar-wrapper {
    padding: 0.0625rem 0.625rem;
    .navbar-contact,
    .navbar-search {
      padding: 1.4375rem 0.5rem 0;
    }
    .navbar-account {
      padding: 1.375rem 0.5rem 0;
    }
    .navbar-minicart {
      padding: 1.125rem 1.25rem 0 0.5rem;
    }
  }
}
@media only screen and (min-width: 48em) {
  .header {
    .header-wrapper {
      .x-wrapper {
        .navbar {
          height: 63px;
          .navbar-wrapper {
            position: fixed;
            top: 0;
            background-color: #ffffff;
            width: 100%;
            padding: 0.0625rem 3.875rem;
            .header__logo {
              float: left;
              padding: 1.3125rem 0 0.9375rem;
              position: static;
              transform: translateX(0);
            }
            .navbar-contact {
              padding: 1.4375rem 1.25rem 0;
            }
            .navbar-search {
              padding: 1.4375rem 1.25rem 0;
            }
            .navbar-account {
              padding: 1.375rem 1.25rem 0;
            }
            .navbar-minicart {
              padding: 1.125rem 2.125rem 0 1.25rem;
            }
            .navbar-toggler {
              display: block;
            }
          }
        }
        .menubar {
          width: 60%;
          display: none;
          .menu-wrapper {
            .navbar-icons {
              .navbar-contact {
                padding: 1.4375rem 1.25rem 0;
              }
              .navbar-search {
                padding: 1.4375rem 1.25rem 0;
              }
              .navbar-account {
                padding: 1.375rem 1.25rem 0;
              }
              .navbar-minicart {
                padding: 1.125rem 2.125rem 0 1.25rem;
              }
            }
          }
        }
      }
      .mobile-menu-wrapper {
        .mobile-menu {
          width: 60%;
          margin-left: 40%;
          .mobile-menu-header {
            .mobile-header__club {
              padding: 1.75rem 0 2.125rem 3.25rem;
            }
            .mobile-header__close-btn {
              padding: 2.1875rem 3.0625rem 1.5625rem 0;
              .button {
                font-size: 0.75rem;
                padding: 0.9375rem 1.875rem;
              }
            }
          }
          .mobile-menu-group {
            .mobile-menu-first {
              .mobile-menu-item {
                .mobile-menu-item-trigger {
                  padding: 1.375rem 3.3125rem 1.375rem 3.4375rem;
                  &:after {
                    right: 3.625rem;
                  }
                }
                .mobile-dropdown-container {
                  .mobile-menu-second {
                    .mobile-menu-second-item {
                      padding: 0 1.25rem;
                      .mobile-menu-second-item__link {
                        padding: 1.375rem 3.3125rem 1.375rem 3.4375rem;
                        &:after {
                          right: 3.625rem;
                        }
                      }
                      &.mobile-menu-second-item__back-btn {
                        width: 60%;
                        & > .mobile-menu-second-item__link {
                          padding-left: 4.75rem;
                          &:after {
                            left: 3.1875rem;
                          }
                        }
                      }
                      .mobile-menu-third {
                        .mobile-menu-third-item {
                          padding: 0 1.25rem;
                          .mobile-menu-third-item__link {
                            padding: 1.375rem 3.3125rem 1.375rem 3.4375rem;
                            &:after {
                              right: 3.625rem;
                            }
                          }
                          &.mobile-menu-third-item__back-btn {
                            width: 60%;
                            & > .mobile-menu-third-item__link {
                              padding-left: 4.75rem;
                              &:after {
                                left: 3.1875rem;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  .dropdown-layer-content {
                    .mobile-dropdown-layer__content-item {
                      margin: 1.25rem 3.9375rem 1.25rem 3.4375rem;
                      &:first-of-type {
                        margin-top: 2.5rem;
                      }
                      &:last-of-type {
                        margin-bottom: 2.5rem;
                      }
                      .mobile-dropdown-layer__content-item-label {
                        bottom: -0.0625rem;
                        left: -0.0625rem;
                      }
                      .mobile-dropdown-layer__content-item-flag {
                        top: 1.25rem;
                      }
                      &.mobile-dropdown-layer__content-item--secondary {
                        margin-left: 3.4375rem;
                        &:first-child {
                          margin-top: 0;
                        }
                      }
                    }
                  }
                }
                .mobile-menu-item__loggle {
                  margin: 0.9375rem 3.4375rem 2.5rem;
                }
                .mobile-toolbar-items {
                  .mobile-toolbar__item {
                    padding: 0 1.25rem;
                    .mobile-toolbar__item-link {
                      display: block;
                      padding: 1rem 0;
                      font-size: 0.75rem;
                      font-weight: 400;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .search-wrapper {
      .search-container {
        .navigation-bar__search {
          .navigation-bar__search-form {
            margin: 0.75rem 3.875rem;
          }
        }
        .results-container {
          padding: 1.875rem 3.875rem;
        }
      }
    }
  }
}
@media only screen and (max-width: 63.9375em) {
  .header {
    .header-wrapper {
      .notice {
        p {
          span {
            font-size: 12px;
          }
          line-height: 1.2;
        }
      }
      .mobile-menu-wrapper {
        .mobile-menu {
          .mobile-menu-group {
            overflow-y: scroll;
            overflow-x: hidden;
            height: calc(100vh - 114px);
            width: 100%;
            -webkit-overflow-scrolling: touch;
            position: relative;
            .mobile-menu-first {
              position: absolute;
              width: 100%;
              left: 0;
              transition: left 0.5s cubic-bezier(0.77, 0, 0.175, 1);
              .mobile-menu-item {
                &:first-child {
                  padding-top: 0.0625rem;
                }
                .mobile-menu-item-trigger {
                  &:focus,
                  &:hover {
                    text-decoration: none;
                  }
                }
              }
            }
          }
        }
      }
    }
    .mask {
      &.search {
        display: none;
      }
    }
  }
}

@media only screen and (min-width: 64em) {
  .header {
    height: auto;
    .header-wrapper {
      .notice {
        position: static;
        &.fixed {
          position: fixed; top: 0;
        }
      }
      .toolbar {
        padding: 0.375rem 1.875rem 0.3125rem;
      }
      .x-wrapper {
        .navbar {
          height: auto;
          .navbar-wrapper {
            padding: 1.875rem 1.875rem 1.25rem;
            position: relative;
            background-color: transparent;
            .header__logo {
              float: none;
              padding: 0;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
            .navbar-contact {
              padding: 0.625rem 0.9375rem;
            }
            .navbar-search {
              padding: 0.625rem 0.9375rem;
            }
            .navbar-account {
              padding: 0.5625rem 0.9375rem 0.3125rem;
            }
            .navbar-minicart {
              padding: 0.3125rem 0.875rem 0.3125rem 0.9375rem;
            }
            //
            &.has-notice {
              top: 0;
            }
          }
        }
        .menubar {
          display: block;
          position: relative;
          right: auto;
          top: auto;
          width: 100%;
          height: auto;
          padding: 0 1.875rem;
          z-index: auto;
          background-color: transparent;
          .menu-wrapper {
            .menu-container {
              .menu-list {
                .menu-item {
                  float: left;
                  padding: 0 1.5rem 0 0;
                  .dropdown-container {
                    padding: 0 1.875rem;
                  }
                  .col-md-r20{
                    width: 20%;
                    flex-basis: auto;
                  }
                }
                .col-md-r20{
                  width: 20%;
                  flex-basis: auto;
                }
              }
            }
            .navbar-icons {
              .navbar-contact {
                padding: 0.625rem 0.9375rem;
              }
              .navbar-search {
                padding: 0.625rem 0.9375rem;
              }
              .navbar-account {
                padding: 0.5625rem 0.9375rem 0.3125rem;
              }
              .navbar-minicart {
                padding: 0.3125rem 0.875rem 0.3125rem 0.9375rem;
              }
            }
          }
        }
      }
    }
    .search-wrapper {
      position: fixed;
      top: 7rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 12;
      width: 96%;
      max-width: 75rem;
      background-color: #fff;
      // display: none;
      display: block;
      .search-container {
        position: relative;
        height: 100%;
        padding: 6.25rem 3.0625rem 4.375rem;
        .search__close-button {
          position: absolute;
          top: 1.875rem;
          right: 3.4375rem;
          opacity: 0;
        }
        .navigation-bar__search {
          position: relative;
          padding: 0.625rem 0.9375rem;
          background-color: transparent;
          .navigation-bar__search-form {
            margin: 0;
            opacity: 0;
            .search-trigger {
              position: static;
            }
            .search-field {
              font-size: 1.5625rem;
              background-color: transparent;
              border-radius: 0;
              text-indent: 0;
              padding-right: 1.25rem;
            }
          }
        }
        .results-container {
          position: static;
          padding: 0;
          justify-content: center;
          height: auto;
          max-height: none;
          overflow-x: hidden;
          &.active {
            display: flex;
            opacity: 0;
          }
          .search-suggestions {
            padding: 0 0.3125rem;
            .search-suggestions__list {
              .search-suggestions__item {
                .search-suggestions__link {
                  line-height: 1.3125rem;
                }
              }
            }
          }
          .search-suggestions--default {
            display: inline-block;
          }
        }
        .suggestions-wrapper {
          margin-top: 6.25rem;
        }
      }
    }
    &.float-mode {
      height: 0;
      .header-wrapper {
        .x-wrapper {
          position: absolute;
          width: 100%;
          .navbar .navbar-wrapper {
            background: transparent;
          }
        }
      }
    }
    &.transparent-mode {
      .header-wrapper {
        .x-wrapper {
          background: transparent;
          &.no-transparent {
            background: #ffffff;
            .navbar .navbar-wrapper {
              .sisley-club .club-desc {
                color: #000000;
              }
              .header__logo {
                .svg-inline--default {
                  display: block;
                }
                .l-header__logo--white,
                .l-header__logo--white .svg-inline--transparent {
                  display: none;
                }
              }
              .navbar-contact,
              .navbar-search,
              .navbar-account,
              .navbar-minicart {
                .navbar-trigger {
                  .svg-inline--default {
                    display: block;
                  }
                  .svg-inline--transparent {
                    display: none;
                  }
                  .navbar-minicart-quantity {
                    background-color: #000000;
                    color: #ffffff;
                  }
                  &:hover {
                    .svg-inline--default {
                      display: block;
                    }
                    .svg-inline--transparent {
                      display: none;
                    }
                    .navbar-minicart-quantity {
                      background-color: #ffffff;
                      color: #000000;
                    }
                  }
                }
              }
            }
            .menubar .menu-wrapper:not(.fixed) {
              .menu-container .menu-list .menu-item .menu-item-link {
                color: #000000;
              }
              &.fixed .menu-container .menu-list .menu-item .menu-item-link {
                color: #ffffff;
              }
              .menu-logo--large {
                border: 0.0625rem solid #dfdfdf;
                .svg-inline--default {
                  display: block;
                }
                .svg-inline--transparent {
                  display: none;
                }
                &:hover {
                  .logo-small {
                    display: none;
                  }
                  .logo-small__white {
                    display: inline;
                  }
                }
              }
            }
          }
          .navbar .navbar-wrapper {
            background: transparent;
            .sisley-club .club-desc {
              color: #ffffff;
            }
            .header__logo {
              .svg-inline--default {
                display: none;
              }
              .l-header__logo--white,
              .l-header__logo--white .svg-inline--transparent {
                display: block;
              }
            }
            .navbar-contact,
            .navbar-search,
            .navbar-account,
            .navbar-minicart {
              .navbar-trigger {
                .svg-inline--default {
                  display: none;
                }
                .svg-inline--transparent {
                  display: block;
                }
                .navbar-minicart-quantity {
                  background-color: #ffffff;
                  color: #000000;
                }
                &:hover {
                  .svg-inline--default {
                    display: block;
                  }
                  .svg-inline--transparent {
                    display: none;
                  }
                  .navbar-minicart-quantity {
                    background-color: #000000;
                    color: #ffffff;
                  }
                }
              }
            }
            .navbar-toggler {
              .svg-inline--default {
                display: none;
              }
              .svg-inline--transparent {
                display: block;
              }
            }
          }
          .menubar .menu-wrapper {
            .menu-container .menu-list .menu-item .menu-item-link {
              color: #ffffff;
            }
            &.fixed .menu-container .menu-list .menu-item .menu-item-link {
              color: #000000;
            }
            .menu-logo--large {
              border-color: hsla(0, 0%, 100%, 0.3);
              .svg-inline--default {
                display: none;
              }
              .svg-inline--transparent {
                display: block;
              }
            }
          }
        }
      }
    }
    &.force-black,
    &.force-black.transparent-mode {
      .header-wrapper {
        .x-wrapper {
          background: transparent;
          &.no-transparent {
            background: #ffffff;
            .navbar .navbar-wrapper {
              .sisley-club .club-desc {
                color: #000000;
              }
              .header__logo {
                .svg-inline--default {
                  display: block;
                }
                .l-header__logo--white,
                .l-header__logo--white .svg-inline--transparent {
                  display: none;
                }
              }
              .navbar-contact,
              .navbar-search,
              .navbar-account,
              .navbar-minicart {
                .navbar-trigger {
                  .svg-inline--default {
                    display: block;
                  }
                  .svg-inline--transparent {
                    display: none;
                  }
                  .navbar-minicart-quantity {
                    background-color: #000000;
                    color: #ffffff;
                  }
                  &:hover {
                    .svg-inline--default {
                      display: block;
                    }
                    .svg-inline--transparent {
                      display: none;
                    }
                    .navbar-minicart-quantity {
                      background-color: #ffffff;
                      color: #000000;
                    }
                  }
                }
              }
            }
            .menubar .menu-wrapper:not(.fixed) {
              .menu-container .menu-list .menu-item .menu-item-link {
                color: #000000;
              }
              &.fixed .menu-container .menu-list .menu-item .menu-item-link {
                color: #ffffff;
              }
              .menu-logo--large {
                // border: .0625rem solid #dfdfdf;
                border-color: rgba(0, 0, 0, 0.3);
                .svg-inline--default {
                  display: block;
                }
                .svg-inline--transparent {
                  display: none;
                }
                &:hover {
                  .logo-small {
                    display: none;
                  }
                  .logo-small__white {
                    display: inline;
                  }
                }
              }
            }
          }
          .navbar .navbar-wrapper {
            background: transparent;
            .sisley-club .club-desc {
              color: #000;
            }
            .header__logo {
              .svg-inline--default {
                display: block;
              }
              .l-header__logo--white,
              .l-header__logo--white .svg-inline--transparent {
                display: none;
              }
            }
            .navbar-contact,
            .navbar-search,
            .navbar-account,
            .navbar-minicart {
              .navbar-trigger {
                .svg-inline--default {
                  display: block;
                }
                .svg-inline--transparent {
                  display: none;
                }
                .navbar-minicart-quantity {
                  background-color: #000;
                  color: #fff;
                }
                &:hover {
                  .svg-inline--default {
                    display: block;
                  }
                  .svg-inline--transparent {
                    display: none;
                  }
                  .navbar-minicart-quantity {
                    background-color: #fff;
                    color: #000;
                  }
                }
              }
            }
            .navbar-toggler {
              .svg-inline--default {
                display: block;
              }
              .svg-inline--transparent {
                display: none;
              }
            }
          }
          .menubar .menu-wrapper {
            .menu-container .menu-list .menu-item .menu-item-link {
              color: #000;
            }
            &.fixed .menu-container .menu-list .menu-item .menu-item-link {
              color: #000;
            }
            .menu-logo--large {
              // border-color: rgba(223, 223, 223, 1);
              border-color: rgba(0, 0, 0, 0.3);
              .svg-inline--default {
                display: block;
              }
              .svg-inline--transparent {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 74.9375em) {
  .header {
    .header-wrapper {
      .mobile-menu-wrapper {
        .mobile-menu {
          .mobile-menu-group {
            .mobile-menu-first {
              .mobile-menu-item {
                .mobile-menu-item-trigger {
                  &:hover {
                    background-color: #f6f6f6;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 75em) {
  .header {
    .header-wrapper {
      .toolbar {
        padding: 0.375rem 0 0.3125rem;
      }
      .x-wrapper {
        .menubar {
          .menu-wrapper {
            .menu-container {
              .menu-list {
                .menu-item {
                  padding: 0 2.375rem 0 0;
                }
              }
            }
          }
        }
      }
    }
    .search-wrapper {
      .search-container {
        .navigation-bar__search {
          padding: 0 0 0 0.625rem;
        }
        .results-container {
          .search-suggestions {
            .search-suggestions__title {
              margin-bottom: 1.6875rem;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 87.5rem) {
  .header {
    .search-wrapper {
      top: 2rem !important;
      &.fadeInHeight {
        max-height: 90%;
      }
    }
  }
}
</style>
